import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { SelfDiagnosticStepModel } from './model';
import { adapter, SelfDiagnosticStepState } from './state';

export const stateName: string = 'selfDiagnosticStep';
export const selectEntityState: MemoizedSelector<object, SelfDiagnosticStepState> =
  createFeatureSelector<SelfDiagnosticStepState>(stateName);

export const getError = (state: SelfDiagnosticStepState): any => state.error;
export const getIsLoading = (state: SelfDiagnosticStepState): boolean => state.isLoading;
export const getSelected = (state: SelfDiagnosticStepState): SelfDiagnosticStepModel => state.selected;

export const selectError: MemoizedSelector<object, any> = createSelector(selectEntityState, getError);
export const selectIsLoading: MemoizedSelector<object, boolean> = createSelector(selectEntityState, getIsLoading);
export const selectSelected: MemoizedSelector<object, SelfDiagnosticStepModel> = createSelector(selectEntityState, getSelected);

export const selectAll: (state: object) => SelfDiagnosticStepModel[] = adapter.getSelectors(selectEntityState).selectAll;
export const selectById = (id: number) =>
  createSelector(selectAll, (entities: SelfDiagnosticStepModel[]) => {
    return entities ? entities.find(e => +e.id == id) : null;
  });
